/**
 * A FIXED BAR PUBLISHES HOW MUCH OF THE SCREEN'S BOTTOM IT TAKES (DK parity, S1d).
 *
 * Measures `ref`'s element while `active`, publishes its height plus `gap` (the
 * room it floats above the edge) under `name`/`key` (utils/rootLengths), follows
 * it with a ResizeObserver where there is one — a label that wraps, a viewport
 * that turns a phone bar into a hidden one — and withdraws the number the moment
 * the bar is inactive or gone. A browser without ResizeObserver still gets one
 * measurement.
 */
import { useEffect } from 'react';
import { publishRootLength, withdrawRootLength } from '../utils/rootLengths';

export default function usePublishedHeight(ref, { name, key, gap = 0, active = true }) {
  useEffect(() => {
    const node = ref.current;
    if (!active || !node) {
      withdrawRootLength(name, key);
      return undefined;
    }
    const measure = () => {
      const height = node.getBoundingClientRect().height;
      publishRootLength(name, key, height > 0 ? height + gap : 0);
    };
    measure();
    let observer = null;
    if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'function') {
      observer = new window.ResizeObserver(measure);
      observer.observe(node);
    }
    return () => {
      if (observer) observer.disconnect();
      withdrawRootLength(name, key);
    };
  }, [ref, name, key, gap, active]);
}
